import { useCallback, useContext, useEffect, useState } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { Destructor } from 'app/shared/utilities/Destructor';

/**
 * Returns the selected asset id and updates every time a new selection is made
 */
export function useSelection() {
    const { selectionService } = useContext(ServicesContext);
    const initialSelection = selectionService.getSelection();
    const [selection, setSelection] = useState(initialSelection);

    const isSelected = useCallback(
        (id: number | string | null) => {
            return selection.length === 0 ? true : selection[0]?.id == id;
        },
        [selection],
    );

    useEffect(() => {
        const destructor = new Destructor(
            selectionService.onSelectionChange(({ selection }) => {
                setSelection(selection);
            }),
        );

        return destructor.destroy;
    }, [selectionService]);

    return {
        selection: selection.length === 0 ? null : selection[0],
        isSelected,
    };
}
